import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace AKCFarmDog {
  export const form:IEventRegisterRow[] = [{
    inputs: []
  }];
}
